module.exports = __webpack_public_path__ + "static/img/icon_code_01.7d20672.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_code_01.png
// module id = oF9H
// module chunks = 11